module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('b', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsa1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/05_9781589809628_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsa"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/06_9781589809628_Acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/07_9781589809628_Ch01"
    }
  }, [_vm._v("Chapter 1   A Horrible and Fiendish Murder and a Swift and Merited Vengeance")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/08_9781589809628_Ch02"
    }
  }, [_vm._v("Chapter 2   Baxter Springs: First Kansas Cow Town")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/09_9781589809628_Ch03"
    }
  }, [_vm._v("Chapter 3   The Notorious Bud Blount: They Didn’t Know Who They Were Foolin’ With")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/10_9781589809628_Ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4   George Hudson: Autocrat on the Criminal Throne")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/11_9781589809628_Ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5   A Fatal Affray in Douglas County")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/12_9781589809628_Ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6   The Daring and Defiant Bob Layton")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/13_9781589809628_Ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7   Britton the Bold")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_9781589809628_Ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8   Pink Fagg: A Notorious Gambler and Desperate Character")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_9781589809628_Ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9   The Hudspeth-Watkins Case: A Criminal Intimacy")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/16_9781589809628_Ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10  The Exciting Pastime of Shooting at One Another")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/17_9781589809628_Ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11  Olyphant: The Last Great Arkansas Train Robbery")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/18_9781589809628_Ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12  The Meadows-Bilyeu Feud: A Pitched and Bloody Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/19_9781589809628_Ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13  The Missouri Kid and the Union Bank Robbery")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/20_9781589809628_Ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14  The Lynching Era in the Ozarks")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/21_9781589809628_Ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15  The Damnable Act of One Hell-Born Fiend")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/22_9781589809628_Ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16  As Mean as the Devil Would Let Him Be: The Last Hanging in Arkansas")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/23_9781589809628_Ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17  The Greatest Tragedy That Ever Befell Pleasant Hill")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/24_9781589809628_Ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18  Lamar’s Lynching of Lynch: The Most Dangerous Man I Ever Saw")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/25_9781589809628_Ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19  Bonnie and Clyde Ride Again")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/26_9781589809628_Ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20  Wilbur Underhill: Lover’s Lane Bandit to Tri-State Terror")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/27_9781589809628_Ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21  What a Man Sows, That Shall He Also Reap: The Last Legal Hanging in Missouri")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/28_9781589809628_Ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22  Bobby Camden: Robin Hood of the Ozarks")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsa"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_9781589809628_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7660686c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/04_9781589809628_Contents.vue
// module id = 69
// module chunks = 0